import React, { useState, useRef } from "react";
import { motion } from "framer-motion";
import { useSelector } from "react-redux";
import { RootState } from "src/store/store";
import { DevConfig } from "src/utils/config";


interface PostTableProps {
    contents: {
        channel_title?: string;
        view_rate?: number;
        view_cnt?: number;
        message_id?: number;
        message?: string;
        channel_id?: string;
        recommend?: boolean;
        photo?: string;
    }[];
}

const PostTable: React.FC<PostTableProps> = ({ contents }) => {
    const expandedRowRef = useRef<number | null>(null);
    const [, forceUpdate] = useState(0);
    const postCategory = useSelector((state: RootState) => state.category.postCategoryId);

    const toggleRow = (index: number) => {
        expandedRowRef.current = expandedRowRef.current === index ? null : index;
        forceUpdate(prev => prev + 1);
      };


    const ClickLink = (path: string) => {
        window.open(path, "_blank");
    };    
    return (
        <div className="table">
            <table className="table table-white table-hover">
                <colgroup>
                    <col style={{width: "85%"}} />
                    <col style={{width: "15%"}} />
                </colgroup>
                <thead>
                    <tr>
                        <th className="text-center text-black3">
                            <p>내용</p>
                        </th>
                        { 
                        postCategory === 0 ?
                        <th className="text-center text-black3">
                            <p>열람율</p>
                        </th>
                        :<th className="text-center text-black3">
                            <p>조회수</p>
                        </th>
                        }
                    </tr>
                </thead>
                <tbody>
                    {contents.filter(content => {
                        return content.recommend === true;
                    })
                    .map((content, index) => (
                        <tr 
                            key={index} 
                            className="highlight"
                            onClick={() => ClickLink(`${DevConfig.TELEGRAM_URL}/${content.channel_id}/${content.message_id}`)} 
                            style={{ cursor: "pointer" }}>
                            <td>
                            <div className="d-flex gap-2">
                                <div className="user_img" style={{ backgroundImage: `url(${content.photo})`}}></div>
                                <div className="txt">
                                    <p className="fw-semibold ellipsis-box">
                                        {content.channel_title}
                                    </p>
                                    <small className="fw-semibold text-black5 ellipsis-box small-test">
                                        {content.message}
                                    </small>
                                </div>
                            </div>
                            </td>
                            { postCategory === 0 ? <td className="text-center text-black5">{content.view_rate?.toFixed(1)}%</td> : <td className="text-center text-black5">{content.view_cnt?.toLocaleString()}</td> }
                        </tr>
                    ))}
                    {contents.filter(content => {
                        return content.recommend !== true;
                    })
                    .map((content, index) => (
                        <tr 
                            key={index}
                            onClick={() => toggleRow(index)}
                            style={{ cursor: "pointer" }}
                        >    
                        {expandedRowRef.current === index ?
                            <td colSpan={2}>
                                <div className="d-flex gap-2">
                                    <div className="user_img" style={{ backgroundImage: `url(${content.photo})`}}></div>
                                    <div className="txt">
                                        <p className="fw-semibold ellipsis-box p-test">
                                            {content.channel_title}
                                        </p>
                                            <motion.small 
                                                className="text-black5 small-test-after" 
                                                style={{whiteSpace:"pre-line", wordBreak:"break-all", lineHeight:"1.56"}}
                                                initial={{ opacity: 0, height: 0 }} 
                                                animate={{ opacity: 1, height: "auto" }} 
                                                exit={{ opacity: 0, height: 0 }}
                                            >
                                                <br />
                                                {content.message?content.message:"[이미지]"}
                                            </motion.small>
                                    </div>
                                    <div className="user_block"></div>
                                </div>
                                <div className="mt-2 text-center">
                                    <motion.button 
                                        className="btn btn-secondary py-2" 
                                        style={{ width: "40%", marginTop: "1.0rem" }}
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1, height: "auto" }} 
                                        onClick={() => window.open(`${DevConfig.TELEGRAM_URL}/${content.channel_id}/${content.message_id}`, "_blank")}
                                    >
                                        채널로 이동하기
                                    </motion.button>
                                </div>
                            </td>
                            :
                            <>
                            <td>
                                <div className="d-flex gap-2">
                                    <div className="user_img" style={{ backgroundImage: `url(${content.photo})`}}></div>
                                    <div className="txt">
                                        <p className="fw-semibold ellipsis-box p-test">
                                            {content.channel_title}
                                        </p>
                                       
                                            <small className="text-black5 ellipsis-box small-test">
                                                {content.message?content.message:"[이미지]"}
                                            </small>
                                        
                                    </div>
                                </div>
                            </td>
                            {postCategory === 0 ? <td className="text-center text-black5">{content.view_rate?.toFixed(1)}%</td> : <td className="text-center text-black5">{content.view_cnt?.toLocaleString()}</td> } 
                            </>
                        }
                        </tr >
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default PostTable;